export const apiListBuy = "/1.0/wsm/report/approval/list"
export const apiDetailBuy = id => `/1.0/wsm/report/approval/${id}/detail`
export const apiListSale = "/1.0/wsm/report/order/list"
export const apiDetailSale = id => `/1.0/wsm/report/order/${id}/detail`
export const apiListInventory = "/1.0/wsm/report/sim/list"
export const apiReportAgencyPurchase = "/1.0/wsm/report-agency/purchase"
export const apiReportAgencyPurchaseDetail = id => `/1.0/wsm/report-agency/purchase/${id}/detail`
export const apiListSaleB2B = "/1.0/wsm/report-agency/sale"
export const apiListInventoryB2B = "/1.0/wsm/report-agency/listInventory"
export const apiReportAgencyPurchaseExport = "/1.0/wsm/report-agency/purchase-export"
export const apiReportAgencySellExport = "/1.0/wsm/report-agency/sale-export"
export const apiExportData = "/1.0/wsm/report/approval/export"
export const apiExportDataInventory = "/1.0/wsm/report/export/sim"
export const apiGetReportAgencyInventoryDetail = id => `/1.0/wsm/report-agency/${id}/detailInventory`
export const apiReportAgencyInventoryExport = "/1.0/wsm/report-agency/export-inventory"
export const apiDetailSimSale = id => `/1.0/wsm/report/order/${id}/detailSim`
export const apiDetailSimPurchase = id => `/1.0/wsm/report/approval/detail/${id}/sim`
export const apiGetDetailInventory = id => `/1.0/wsm/report/sim/${id}/detail`
export const apiGetSaleSettingReport = `/1.0/wsm/report-agency/getBySetting`
export const apiGetListRetailReport = `/1.0/wsm/report-agency/getRetail`
export const apiGetReportAgencyRetailDetail = id => `/1.0/wsm/report-agency/purchase/${id}/detail`
export const apiExportExcelReportRetail = "/1.0/wsm/report-agency/retail-export"